import { useMemo } from 'react';
import { BarDatum } from '@nivo/bar';
import { Datum } from '@nivo/line';

import { TapAnswer } from '../../../../api';

export interface LegendData {
  label: string;
  color: string;
  id: string;
  textColor: string;
}

// FIX: the currently publised version of Nivo doesn't expose legends to custom layers
// this will be fixed in the next publised version
// V0.79.1: https://github.com/plouc/nivo/blob/v0.79.1/packages/bar/src/Bar.tsx#L358
// master:  https://github.com/plouc/nivo/blob/master/packages/bar/src/Bar.tsx#L373
export function useCustomBarLegend({
  data,
  layerData,
  hiddenSeries,
  answersById,
}: {
  data: BarDatum[];
  layerData: Datum[];
  hiddenSeries: string[];
  answersById: Record<string, TapAnswer['attributes']>;
}) {
  const hiddenSeriesSet = useMemo(() => {
    return new Set(hiddenSeries);
  }, [hiddenSeries]);

  const legendsData = useMemo(() => {
    const computedLegendsData: LegendData[] = [];

    for (let i = 0; i < layerData.length; i += data.length) {
      const layerValue = layerData[i] as unknown as {
        color: string;
        key: string;
      };

      const id = layerValue.key.split('.')[0];
      computedLegendsData.push({
        color: hiddenSeriesSet.has(id) ? 'gray.200' : layerValue.color,
        label: answersById[id]?.option_text,
        id,
        textColor: hiddenSeriesSet.has(id) ? 'gray.300' : 'gray.700',
      });
    }

    return computedLegendsData;
  }, [answersById, hiddenSeriesSet, layerData, data]);

  return legendsData;
}
